module.exports = __webpack_public_path__ + "img/3d4103f.jpg";